import { ReactComponent as TrashIcon } from "../../../../assets/trashIcon.svg";
import { OptionModel } from "../../../../modules/createCampaign/models/questionModel";
import { ReactComponent as CheckIcon } from "../../../../assets/checkIcon.svg";
import lightOrDarkColor from "@check-light-or-dark/color";
import "./multipleChoiceOption.scss";
import { useState } from "react";

export default function MultipleChoiceOption(props: {
  isEditable?: boolean;
  viewOnly?: boolean;
  placeholder?: string;
  onChange?: (e: OptionModel) => void;
  initialValue?: OptionModel;
  value?: string;
  isFocused?: boolean;
  maxWidth?: string;
  onClick?: () => void;
  onClickDelete?: () => void;
  border?: string;
  color?: string;
  fontFamily?: string;
  isSelected?: boolean;
}) {
  const [inputValue, setInputValue] = useState(props.initialValue?.option);
  const [inputScore, setScoreValue] = useState(props.initialValue?.score);
  return (
    <div
      className="multiple-choice-option-container"
      onClick={props.onClick}
      style={{
        cursor: props.onClick ? "pointer" : "",

        maxWidth:
          props.isEditable == false || props.viewOnly == true
            ? props.maxWidth
            : `calc(${props.maxWidth} + 0.5rem + 18px)`,
      }}
    >
      <div className="multiple-choice-option" style={{ border: props.border }}>
        <div
          className={`multiple-choice-circle ${
            props.isSelected && "multiple-choose-box-selected"
          }`}
          style={{
            border: props.border,
            backgroundColor: props.isSelected ? props.color : undefined,
          }}
        >
          {props.isSelected && (
            <CheckIcon
              height={10}
              width={10}
              stroke={
                lightOrDarkColor(props.color ?? "") === "light"
                  ? "black"
                  : "white"
              }
            />
          )}
        </div>
        <input
          className={"multiple-choice-input"}
          onClick={props.onClick}
          style={{
            color: props.color,
            cursor: props.onClick ? "pointer" : "",
            fontFamily: props.fontFamily,
          }}
          disabled={props.viewOnly == true}
          placeholder={props.placeholder}
          onChange={(e) => {
            setInputValue(e.target.value);
            props.onChange?.({
              option: e.target.value,
              score: props.initialValue?.score ?? undefined,
            });
          }}
          value={props.value ?? inputValue ?? ""}
          autoFocus={props.isFocused}
        />
        {props.isEditable != false && props.viewOnly != true && (
          <div className="multiple-choice-score-container">
            Score:
            <input
              className={"multiple-choice-score-input"}
              onChange={(e) => {
                let x = !isNaN(parseInt(e.target.value))
                  ? parseInt(e.target.value)
                  : undefined;
                setScoreValue(x);
                props.onChange?.({
                  option: props.initialValue?.option ?? "",
                  score: x,
                });
              }}
              value={inputScore ?? ""}
            />
          </div>
        )}
      </div>
      {props.isEditable != false && props.viewOnly != true && (
        <TrashIcon
          width={20}
          height={20}
          stroke={"black"}
          style={{ cursor: "pointer" }}
          onClick={props.onClickDelete}
        />
      )}
    </div>
  );
}
